module.exports = __webpack_public_path__ + "img/25.990b0c06.jpg";